import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=47f52b90&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f52b90')) {
      api.createRecord('47f52b90', component.options)
    } else {
      api.reload('47f52b90', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=47f52b90&", function () {
      api.rerender('47f52b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/envelopes/edit.vue"
export default component.exports